<template>
  <div id="app">
    <home-header />
    <router-view></router-view>
    <!-- 需要通过 router-view 这个组件 来加载 路由对应的组件 -->
    <index-bottom />
  </div>
</template>

<script>

// import IndexBanner from "./components/IndexBanner.vue";
// import IndexCenter from "./components/IndexCenter.vue";
// import IndexSubject from "./components/IndexSubject.vue";
import IndexBottom from "./components/IndexBottom.vue";
import HomeHeader from "./components/HomeHeader.vue"
export default {
  name: "App",
  components: {
    // IndexBanner,
    // IndexCenter,
    // IndexSubject,
    IndexBottom,
    HomeHeader
  },
  data() {
    return {
      arr: [
        {
          name: "四川国新联程石油化工有限公司招聘公告",
        },
        {
          name: "四川国新联程石油化工有限公司招聘公告",
        },
        {
          name: "四川国新联程石油化工有限公司招聘公告",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style>
body,
ul,
input,
p {
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
}
ul {
  list-style: none;
}
input {
  border: none;
  outline: none;
}
body {
  font-size: 12px;
  color: #333333;
  background: #f0f0f0;
}
.fcb {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.fcc {
  display: flex;
  align-items: center;
  justify-content: center;
}
.w-1200 {
  width: 1200px;
}
.t66 {
  color: #666666;
}
.t99 {
  color: #999999;
}
.t5b {
  color: #005bac;
}
.tff {
  color: #ffffff;
}
.t16 {
  font-size: 16px;
}
.t14 {
  font-size: 14px;
}
.t18 {
  font-size: 18px;
}
.t24 {
  font-size: 24px;
}
.t20 {
  font-size: 20px;
}
.h60 {
  height: 60px;
}
.back {
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);
}
.mr20 {
  margin-top: 20px;
}
.mr-r20 {
  margin-right: 20px;
}
body {
  font-family: Microsoft YaHei;
}
a{
  text-decoration: none;
  color: black;
}
.container {
  width: 100%;
  background: #f0f0f0;
}
.bgw{
  background: #FFFFFF;
}
.cp{
  cursor: pointer;
}
.df {
  position: relative;
  display: flex;
}
.w1200 {
  width: 1200px;
}
.ml20{
  margin-left: 20px;
}
.mt40{
  margin-top: 40px;
}
.f-cc {
  display: flex;
  justify-content: center;
  align-content: center;
}
.f-sbc {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

body,
html,
p {
  margin: 0;
  padding: 0;
}
.f12 {
  font-size: 15px;
}
.f16{
  font-size: 16px;
}
.mt14{
  margin-top: 14px;
}
.mt10{
  margin-top: 10px;
}
.mt16{
  margin-top: 16px;
}
.mt12{
  margin-top: 12px;
}
.mtb20{
  margin: 20px 0;
}
.c005{
  color: #005BAC;
}
.mt20{
  margin-top: 20px;
}
.cfff{
  color: #ffffff;
}
.mt18{
  margin-top: 18px;
}
</style>
